import React, { useState, useEffect, useCallback } from 'react';
import AdminLayout from '../components/AdminLayout';
import adminApi from '../services/adminApi';

const NIVEAU_LABELS = {
  licence1: 'Licence 1', licence2: 'Licence 2', licence3: 'Licence 3',
  master1: 'Master 1',   master2: 'Master 2',   doctorat: 'Doctorat',
};

const AdminUsers = () => {
  const [users, setUsers]       = useState([]);
  const [meta, setMeta]         = useState({});
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState('');
  const [alert, setAlert]       = useState(null);
  const [selected, setSelected] = useState(null);

  const load = useCallback((searchVal = '') => {
    setLoading(true);
    adminApi.getUsers({ search: searchVal })
      .then(({ data }) => {
        setUsers(data.data);
        setMeta(data.meta || {});
      })
      .catch(() => setAlert({ type: 'error', msg: 'Impossible de charger les utilisateurs.' }))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSearch = (e) => {
    e.preventDefault();
    load(search);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cet utilisateur ? Cette action est irréversible.')) return;
    try {
      await adminApi.deleteUser(id);
      setAlert({ type: 'success', msg: 'Utilisateur supprimé.' });
      if (selected?.id === id) setSelected(null);
      load(search);
    } catch {
      setAlert({ type: 'error', msg: 'Impossible de supprimer cet utilisateur.' });
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1>Utilisateurs</h1>
        <p>Gérez les membres inscrits sur la plateforme</p>
      </div>

      {alert && (
        <div className={`admin-alert ${alert.type}`}>{alert.msg}</div>
      )}

      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Membres ({meta.total ?? users.length})</h2>
        </div>

        <form className="admin-search-bar" onSubmit={handleSearch}>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Rechercher par nom, prénom, email…"
          />
          <button type="submit" className="admin-btn primary">Rechercher</button>
          {search && (
            <button type="button" className="admin-btn secondary" onClick={() => { setSearch(''); load(''); }}>
              Réinitialiser
            </button>
          )}
        </form>

        {loading ? (
          <p style={{ color: '#aaa', textAlign: 'center', padding: 32 }}>Chargement…</p>
        ) : users.length === 0 ? (
          <div className="admin-empty">
            <div className="empty-icon">👥</div>
            <p>Aucun utilisateur trouvé.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Nom complet</th>
                  <th>Email</th>
                  <th>Université</th>
                  <th>Filière</th>
                  <th>Niveau</th>
                  <th>Inscrit le</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>
                      <strong>{u.prenom} {u.nom}</strong>
                    </td>
                    <td>{u.email}</td>
                    <td style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {u.universite || '—'}
                    </td>
                    <td style={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {u.filiere || '—'}
                    </td>
                    <td>{NIVEAU_LABELS[u.niveau] || u.niveau || '—'}</td>
                    <td>{u.created_at || '—'}</td>
                    <td>
                      <div className="table-actions">
                        <button className="admin-btn secondary" onClick={() => setSelected(u)}>Voir</button>
                        <button className="admin-btn danger" onClick={() => handleDelete(u.id)}>Supprimer</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {selected && (
        <div className="admin-form-overlay" onClick={() => setSelected(null)}>
          <div className="admin-form-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Profil utilisateur</h3>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 20px', fontSize: 14 }}>
              {[
                ['Prénom',      selected.prenom],
                ['Nom',         selected.nom],
                ['Email',       selected.email],
                ['Téléphone',   selected.telephone],
                ['Université',  selected.universite],
                ['Filière',     selected.filiere],
                ['Niveau',      NIVEAU_LABELS[selected.niveau] || selected.niveau],
                ['Date naiss.', selected.date_naissance],
                ['Inscrit le',  selected.created_at],
              ].map(([label, val]) => (
                <div key={label}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', marginBottom: 2 }}>
                    {label}
                  </div>
                  <div style={{ color: '#1a1a2e', fontWeight: 500 }}>{val || '—'}</div>
                </div>
              ))}
            </div>

            <div className="form-actions">
              <button className="admin-btn secondary" onClick={() => setSelected(null)}>Fermer</button>
              <button className="admin-btn danger" onClick={() => handleDelete(selected.id)}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminUsers;
